/**
 * QR de paiement SEPA (norme EPC069-12, version 002).
 *
 * La librairie `qrcode` est chargée paresseusement : si elle n'est pas
 * installée, l'option QR est simplement indisponible et la facture reste
 * entièrement fonctionnelle.
 */

const LIMITE_OCTETS = 331
const LONGUEUR_MAX_BENEFICIAIRE = 70

let librairie
let librairieCherchee = false

function chargerLibrairie () {
  if (librairieCherchee) return librairie
  librairieCherchee = true
  try {
    librairie = require('qrcode')
  } catch (erreur) {
    librairie = null
  }
  return librairie
}

export function qrDisponible () {
  return !!chargerLibrairie()
}

function longueurEnOctets (texte) {
  // Chaque octet non ASCII devient une séquence %XX : un accent compte double
  return encodeURIComponent(texte).replace(/%[0-9A-F]{2}/g, 'x').length
}

/**
 * Construit la charge utile EPC, ou null si les données ne permettent pas un
 * QR valide (mieux vaut pas de QR qu'un QR que la banque refuse).
 */
export function construirePayloadEpc (donnees) {
  const beneficiaire = String((donnees && donnees.beneficiaire) || '').trim()
  const iban = String((donnees && donnees.iban) || '').replace(/[\s ]/g, '').toUpperCase()
  const bic = String((donnees && donnees.bic) || '').replace(/[\s ]/g, '').toUpperCase()
  const montant = Number(donnees && donnees.montant)

  if (!beneficiaire || !iban) return null
  if (beneficiaire.length > LONGUEUR_MAX_BENEFICIAIRE) return null
  if (!isFinite(montant) || montant < 0.01 || montant > 999999999.99) return null

  const communication = String((donnees && donnees.communication) || '').trim()
  const libre = String((donnees && donnees.communicationLibre) || '').trim()

  const lignes = [
    'BCD',
    '002',
    '1',
    'SCT',
    bic,
    beneficiaire,
    iban,
    'EUR' + montant.toFixed(2),
    '',
    // Lignes 10 et 11 mutuellement exclusives : référence structurée OU libre
    communication,
    communication ? '' : libre,
    ''
  ]

  const payload = lignes.join('\n')
  return longueurEnOctets(payload) > LIMITE_OCTETS ? null : payload
}

/**
 * Renvoie une promesse résolue avec le dataURL du QR, ou null si le QR n'est
 * pas générable (librairie absente, données incomplètes, échec d'encodage).
 */
export function genererQrDataUrl (donnees) {
  const qrcode = chargerLibrairie()
  if (!qrcode) return Promise.resolve(null)

  const payload = construirePayloadEpc(donnees)
  if (!payload) return Promise.resolve(null)

  return new Promise(function (resoudre) {
    qrcode.toDataURL(payload, {errorCorrectionLevel: 'M', margin: 1, width: 240},
      function (erreur, dataUrl) {
        resoudre(erreur ? null : dataUrl)
      })
  })
}

export default {qrDisponible, construirePayloadEpc, genererQrDataUrl}



// WEBPACK FOOTER //
// ./src/utils/facture/epc.js